// extracted by mini-css-extract-plugin
module.exports = {"dashboardAds":"dashboard-ads_dashboardAds__26XXO","carousel":"dashboard-ads_carousel__1iA7o","item":"dashboard-ads_item__moc_J","placeholder":"dashboard-ads_placeholder__rYBcr"};